import { render } from "./LanguageSelector.vue?vue&type=template&id=af1ca5da"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/CardGen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__